var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneShake(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.97,
    height: 48.053,
    viewBox: "0 0 47.97 48.053",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone_Shake",
    transform: "translate(-0.015 0.076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Smart_Phone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M11.8,4,28.6,1A3.761,3.761,0,0,1,33,4.1l6.2,35.4a3.761,3.761,0,0,1-3.1,4.4l-16.8,3a3.761,3.761,0,0,1-4.4-3.1L8.7,8.4A3.812,3.812,0,0,1,11.8,4Z",
    fill: "none",
    stroke: "#082ac8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 1.9,
    cy: 1.9,
    r: 1.9,
    transform: "translate(24.891 40.152) rotate(-9.997)",
    fill: "#082ac8"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    y1: 4.2,
    x2: 24.2,
    transform: "translate(14.3 35.9)",
    fill: "none",
    stroke: "#082ac8",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    x2: 3.4,
    y2: 19.7,
    transform: "translate(39.8 9.5)",
    fill: "none",
    stroke: "#082ac8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    x2: 2.4,
    y2: 13.8,
    transform: "translate(44.6 11)",
    fill: "none",
    stroke: "#082ac8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    x2: 3.4,
    y2: 19.7,
    transform: "translate(4.8 17)",
    fill: "none",
    stroke: "#082ac8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    x2: 2.4,
    y2: 13.8,
    transform: "translate(1 21.5)",
    fill: "none",
    stroke: "#082ac8",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneShake);
export default __webpack_public_path__ + "static/media/Phone_Shake.60f18f58e23c62da26144c964163b662.svg";
export { ForwardRef as ReactComponent };